import React, {Fragment} from 'react';
import styled from 'styled-components';
import {actionIcExplore24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {labels} from '../../../../../util/utils';
import Utility from '../../../../../util/utilityfunctions';
import Icon from '../../../../Common/BaseComponentWrappers/MotifIcon';

function PrintViewGuidanceBody(props) {
	const {guidanceDetails} = props;

	const guidanceList = guidanceDetails && guidanceDetails.filter((g) => g.id !== 0 || g.guidanceId !== 0);

	return (
		<>
			{guidanceList && guidanceList.length > 0 ? (
				<StyledPrintViewGuidanceBody className="StyledPrintViewGuidanceBody">
					<section className="guidanceIcon" title={labels.guidance}>
						<Icon src={actionIcExplore24px} />
					</section>
					{guidanceList.sort(Utility.sortByMultipleKey(['GuidanceDisplayOrder', 'GuidanceName'])).map((guidance, i) => {
						return (
							<Fragment key={guidance.guidanceId}>
								<section className="guidanceLink">
									<span>{guidance.guidanceName}</span>
								</section>
								{guidanceDetails[i + 1] ? (
									<Fragment>
										<section className="guidanceLink">
											<span>{'|'}</span>
										</section>
									</Fragment>
								) : (
									''
								)}
							</Fragment>
						);
					})}
				</StyledPrintViewGuidanceBody>
			) : (
				<></>
			)}
		</>
	);
}

const StyledPrintViewGuidanceBody = styled.section`
	margin-top: var(--px-10);
	&.SectionBodyWrapper {
		flex-direction: unset !important;
		padding: var(--px-10) !important;
		border-bottom: var(--px-1) solid var(--neutrals-300) !important;
		margin-top: calc(var(--px-10) * -1) !important;
		border-top: 0 !important;
	}
	.guidanceIcon {
		display: inline-flex;
		margin-right: var(--px-3);
	}
	.guidanceLink {
		display: inline-flex;
		padding: 0 var(--px-7);
		&:hover {
			text-decoration: none;
		}
	}
`;

export default PrintViewGuidanceBody;
